import React from 'react'
import Header from './Header';
import './Mypost.css';
// import { submiterror } from './SubmitProm';
// import base64convertor from '../converterfunction';
import Formd from './Form_d';
export default function MyPost() {

  return (
    <div className='From_page'>
      <Header />
      <Formd />
    </div>
  );
}
